var messages = {
  placeholder: '请输入',
  size: '字体大小',
  color: '字体颜色',
  background: '背景颜色',
  bold: '加粗',
  italic: '斜体',
  underline: '下划线',
  strike: '删除线',
  indent: {
    '-1': '向前缩进',
    '+1': '向后缩进'
  },
  list: {
    ordered: '有序列表',
    bullet: '无序列表'
  },
  align: '对齐',
  link: '链接',
  image: '上传图片',
  video: '上传视频',
  clean: '清除格式'
};
export default messages;